<template>
  <div>
    <h-title with-mb>Dashboard</h-title>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12 py-3">
        <base-box bg="#EAD8F5">
          <box-chart icon="exchange-alt" title="TRANSACTION">
            <h3 class="fw-bold mt-3">Rp. 56.000.000</h3>
            <p class="m-0">This Week</p>
          </box-chart>
        </base-box>
      </div>
      <div class="col-lg-3 col-md-6 col-12 py-3">
        <base-box bg="#D8F5E5">
          <box-chart icon="cart-arrow-down" title="ORDER" iconChart="chart1.svg">
            <h3 class="fw-bold mt-3">530</h3>
            <p class="m-0">This Week</p>
          </box-chart>
        </base-box>
      </div>
      <div class="col-lg-3 col-md-6 col-12 py-3">
        <base-box bg="#D8EAF5">
          <box-chart icon="user-circle" title="CUSTOMER">
            <h3 class="fw-bold mt-3">+ 210</h3>
            <p class="m-0">This Week</p>
          </box-chart>
        </base-box>
      </div>
      <div class="col-lg-3 col-md-6 col-12 py-3">
        <base-box bg="#F5D8E0">
          <box-chart icon="archive" title="PRODUCT">
            <h3 class="fw-bold mt-3">+ 321</h3>
            <p class="m-0">This Week</p>
          </box-chart>
        </base-box>
      </div>
    </div>
    <div class="row pt-5">
      <div class="col-lg-6 col-12">

        <!-- TRANSACTION LIST -->
        <h-title>Lastest Transaction</h-title>
        <div class="pt-3 list-transaction">
          <base-radio name="transaction" id="transaction-1" >
            <template v-slot:label>
              <!-- <base-box radius="26"> -->
                <base-icon icon="exchange-alt"></base-icon>
                <div class="order-text ms-3">
                  <p class="fw-bold mb-0">Order #23293</p>
                  <small>Item Name 1, Item Name 2, <span class="fw-bold">+3 More</span></small>
                </div>
              <!-- </base-box> -->
            </template>
          </base-radio>
          <base-radio name="transaction" id="transaction-2" >
            <template v-slot:label>
              <!-- <base-box radius="26"> -->
                <base-icon icon="exchange-alt"></base-icon>
                <div class="order-text ms-3">
                  <p class="fw-bold mb-0">Order #23293</p>
                  <small>Item Name 1, Item Name 2, <span class="fw-bold">+3 More</span></small>
                </div>
              <!-- </base-box> -->
            </template>
          </base-radio>
          <base-radio name="transaction" id="transaction-3" >
            <template v-slot:label>
              <!-- <base-box radius="26"> -->
                <base-icon icon="exchange-alt"></base-icon>
                <div class="order-text ms-3">
                  <p class="fw-bold mb-0">Order #23293</p>
                  <small>Item Name 1, Item Name 2, <span class="fw-bold">+3 More</span></small>
                </div>
              <!-- </base-box> -->
            </template>
          </base-radio>
          <base-radio name="transaction" id="transaction-4" >
            <template v-slot:label>
              <!-- <base-box radius="26"> -->
                <base-icon icon="exchange-alt"></base-icon>
                <div class="order-text ms-3">
                  <p class="fw-bold mb-0">Order #23293</p>
                  <small>Item Name 1, Item Name 2, <span class="fw-bold">+3 More</span></small>
                </div>
              <!-- </base-box> -->
            </template>
          </base-radio>
          <base-radio name="transaction" id="transaction-5" >
            <template v-slot:label>
              <!-- <base-box radius="26"> -->
                <base-icon icon="exchange-alt"></base-icon>
                <div class="order-text ms-3">
                  <p class="fw-bold mb-0">Order #23293</p>
                  <small>Item Name 1, Item Name 2, <span class="fw-bold">+3 More</span></small>
                </div>
              <!-- </base-box> -->
            </template>
          </base-radio>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="d-flex align-items-center justify-content-between">
          <h-title>Statistic</h-title>
          <base-select v-model="chartFilter" :options="selectOptions"></base-select>
        </div>
        <div class="chart">
          <bar-chart />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTitle from '@/components/text/BaseTitle'
import BaseBox from '@/components/BaseBox'
import BaseRadio from '@/components/input/BaseRadio'
import BaseSelect from '@/components/input/BaseSelect'
import BoxChart from '@/components/dashboard/BoxChart'
import BaseIcon from '@/components/BaseIcon'
import BarChart from '@/components/dashboard/BarChart'
export default {
  components: {
    HTitle,
    BaseBox,
    BoxChart,
    BaseRadio,
    BaseSelect,
    BaseIcon,
    BarChart
  },
  data() {
    return {
      chartFilter: '',
      selectOptions: [
        {value: 'transaction', text: 'Transaction'},
        {value: 'customer', text: 'Customer'},
        {value: 'product', text: 'Product'},
      ]
    }
  },
  beforeMount(){
    this.$store.state.transPanelMenu = 0;
  }
}
</script>

<style>

</style>